import { Container, Grid, LinearProgress, Stack, Typography } from "@mui/material";
import { BusquedaProyectos } from "../../componentes/BuquedaProyectos";
import { useContext, useEffect, useState } from "react";
import { ProyectoBusqueda } from "../../interfaces/ProyectoBusqueda";
import { CasUserContext } from "../../services/casUserContext";
import { useNavigate } from "react-router-dom";
import UsuarioService from "../../services/UsuarioService";
import ProyectoService from "../../services/ProyectoService";
import { UnauthorizedPage } from "../Error/ErrorUnauthorized";
import ProductoService from "../../services/ProductoService";
import AlertService from "../../services/AlertService";
import BusqProyTable from "../../componentes/Proyectos/BusqProyTable";

const alertaService = new AlertService();
const usuarioService = new UsuarioService();
const proyectoService = new ProyectoService();
const productoService = new ProductoService();

export const ProyectosAprobadosPage: React.FC<{}> = () => {
  const [data, setData] = useState<Array<ProyectoBusqueda>>([]);
  const [auth, setAuth] = useState(false);
  const [ready, setReady] = useState(false);
  const casUserContext = useContext(CasUserContext);
  const token = casUserContext.token;
  const user = casUserContext.userData;
  let history = useNavigate();
  //Seccion de carga
  useEffect(() => {
    const flag = usuarioService.authorized(user.roles);
    //console.log(user);
    setAuth(flag);
    if (flag) {
      fetchData();
    }
  }, [token]);

  //seccion Funciones
  const fetchData = async () => {
    try {
      alertaService.showLoading("Cargando Datos...");
      //console.log(user.username);
      //console.log(user.nombreCompleto);
      await proyectoService.GetProyectosByUser(user.username, token)
        .then((data) => {
          if (data.status.isSuccessfully) {
            //console.log(data.listData)
            setData(ProyectosAprobados(data.listData));
            alertaService.hideLoading();
          } else {
            alertaService.hideLoading();
            alertaService.alertaAdvertenciaList("ATENCIÓN", data.status.messages);
            setData([]);
          }
        })
        .catch((error) => {
          console.error(error)
          alertaService.hideLoading();
          setData([]);
        });
      setReady(true);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  function ProyectosAprobados(resp: Array<ProyectoBusqueda>): Array<ProyectoBusqueda> {
    let lista = resp.filter(x => x.estado != "Proyecto en la bandeja del director. Proyecto Nuevo.");
    return lista;
  }

  return (
    <Container sx={{ mt: 5, mb: 4, border: '1px solid #517ED3', borderRadius: '5px', padding: '20px', textAlign: 'center' }}>
      <br />
      {auth ?
        <>{ready ?
          <Grid container spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography><strong>Proyectos</strong></Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <BusqProyTable rowsPerPage={[5, 10, 25, 100]} data={data} editable={true} />
            </Grid>
          </Grid>
          :
          <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
            <LinearProgress color="secondary" />
          </Stack>}
        </>
        :
        <UnauthorizedPage />
      }
    </Container>
  );
}